import React from "react";
import {
  Button,
  IconButton,
  InputAdornment,
  InputBase,
  Stack,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SearchIcon from "@mui/icons-material/Search";
import DownloadIcon from "@mui/icons-material/Download";
import { useNavigate } from "react-router";

const HeaderName = ({
  headerName,
  newForm,
  createNewForm,
  onClickBackButton,
  setSearch,
  displaySearch,
  search,
  showDownload, 
}) => {
  const navigate = useNavigate();

  // 🔽 Custom event to trigger CSV export from parent
  const handleDownloadCSV = () => {
    window.dispatchEvent(new CustomEvent("trigger-download-csv"));
  };

  return (
    <>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        style={{ margin: "5px 10px" }}
      >
        <Stack direction={"row"} alignItems={"center"} gap={2}>
          <Typography
            variant="h5"
            component="h1"
            style={{
              display: "flex",
              color: "#004977",
              alignItems: "center",
              fontSize: "30px",
              fontWeight: 600,
              gap: 5,
              cursor: "pointer",
            }}
            onClick={onClickBackButton}
          >
            <ArrowBackIcon />
            {headerName}
          </Typography>
        </Stack>

        <Stack
          direction={"row"}
          spacing={1}
          justifyContent={"flex-end"}
          alignItems={"center"}
        >
           {showDownload && (
      <Button
        variant="contained"
        startIcon={<DownloadIcon />}
        onClick={handleDownloadCSV}
        sx={{
          textTransform: "none",
          backgroundColor: "#04AB44",
          color: "#fff",
          ":hover": {
            backgroundColor: "#04AB44",
          },
        }}
      >
        CSV
      </Button>
    )}
          {displaySearch && (
            <>
              {/* 🔍 Search Box */}
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                sx={{
                  boxShadow: "2px 2px 4px 2px rgba(0, 0, 0, 0.2)",
                  borderRadius: "18px",
                  padding: "3px",
                  backgroundColor: "#F4F7FE",
                }}
              >
                <InputBase
                  id="outlined-basic"
                  variant="outlined"
                  size="small"
                  placeholder="Search"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  sx={{
                    backgroundColor: "#F4F7FE",
                    borderRadius: "49px",
                    padding: "5px",
                  }}
                  startAdornment={
                    <InputAdornment position="start">
                      <IconButton size="small" edge="start">
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </Stack>
            </>
          )}

          {/* 📦 Docket Tracking Button */}
          {headerName === "Docket List" && (
            <Button
              variant="contained"
              onClick={() => navigate("/dashboard/docketlist/docketview")}
              sx={{
                textTransform: "none",
                backgroundColor: "#E7E7E7",
                color: "black",
                ":hover": {
                  backgroundColor: "#E7E7E7",
                  color: "black",
                },
              }}
            >
              Docket Tracking
            </Button>
          )}

          {/* ➕ New Button */}
          {newForm && (
            <Button
              variant="contained"
              startIcon={<AddIcon style={{ color: "#04AB44" }} />}
              onClick={createNewForm}
              sx={{
                textTransform: "none",
                backgroundColor: "#E7E7E7",
                color: "black",
                ":hover": {
                  backgroundColor: "#E7E7E7",
                  color: "black",
                },
              }}
            >
              New
            </Button>
          )}
        </Stack>
      </Stack>
    </>
  );
};

export default HeaderName;
